import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
import 'xdh-map/lib/xdhmap.css';
import 'vuescroll/dist/vuescroll.css';
import posIcon from '@/assets/others/map/location.png';
import { XdhMap, XdhMapType, XdhMapPointer, XdhMapImage, XdhMapGeoLayer, XdhMapLine } from 'xdh-map';
import VueScroll from 'vuescroll/dist/vuescroll-slide';
export default {
  name: 'MapGetPoint',
  components: {
    XdhMap: XdhMap,
    XdhMapPointer: XdhMapPointer,
    XdhMapType: XdhMapType,
    XdhMapImage: XdhMapImage,
    XdhMapGeoLayer: XdhMapGeoLayer,
    XdhMapLine: XdhMapLine,
    VueScroll: VueScroll
  },
  props: {
    isLocation: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.mapCenter = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
  },
  data: function data() {
    return {
      addr: '',
      coordsys: 'autonavi',
      // state: yaan,
      line: [],
      visible: false,
      mapCenter: [118.047928, 24.613341],
      posIcon: posIcon,
      title: '',
      coordinate: '',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      searchurl: 'https://restapi.amap.com/v3/config/district?key=44641f38739649861c9d7d31f69b4ac2',
      maptype: 'Amap2'
    };
  },
  watch: {
    mapCenter: function mapCenter(value) {
      var _this = this;

      if (value) {
        console.log('value', value);
        axios({
          method: 'GET',
          url: "https://api.tianditu.gov.cn/geocoder?postStr={'lon':".concat(value[0], ",'lat':").concat(value[1], ",'ver':1}&type=geocode&tk=a7d9dab319b8bcbf2d0a27dab1988d39")
        }).then(function (res) {
          console.log('res', res);

          if (res.status == 200) {
            _this.addr = res.data.result.addressComponent.province + res.data.result.formatted_address;
          }
        }); // AMap.plugin('AMap.Geocoder', () => {
        //   var geocoder = new AMap.Geocoder({
        //     city: "010", //城市设为北京，默认：“全国”
        //     radius: 1000 //范围，默认：500
        //   });
        //   geocoder.getAddress(this.mapCenter, (status, result) => {
        //     if (status === 'complete' && result.regeocode) {
        //       this.addr = result.regeocode.formattedAddress;
        //       console.log('address', address)
        //     }
        //   });
        // })
      }
    }
  },
  methods: {
    changeMap: function changeMap(e) {
      this.maptype = e.target.value;

      if (e.target.value == 'Amap') {
        this.$refs.myMap.changeType(e.target.value);
      } else {
        this.$refs.myMap.changeType('Amap2');
      }
    },
    searchMap: function searchMap() {
      var _this2 = this;

      if (this.title) {
        //可用filter限制搜索区域,限制参数填入adcode
        // const surl=this.searchurl+"&filter=511800&keywords="+this.title
        var surl = this.searchurl + '&keywords=' + this.title;

        var _that = this;

        this.$jsonp(surl).then(function (res) {
          if (res && res.districts && res.districts.length > 0) {
            var location = res.districts[0].center.split(',');

            _this2.$refs.myMap.moveTo(location);
          } else {
            _that.$message.warning('未查询到对应数据!');
          }
        });
      } else {
        that.$message.warning('请输入需要搜索的关键字');
      }
    },
    mapCilck: function mapCilck() {
      this.mapCenter = this.$refs.mapPointer.coordinate;
    },
    mapReady: function mapReady() {
      this.$refs.myMap.resize();
      this.$refs.myMap.moveTo(this.mapCenter);
    },
    changeCoordsys: function changeCoordsys() {
      var _this3 = this;

      if (this.coordinate && this.coordinate.indexOf(':') != -1) {
        var point = this.coordinate.split(':');
        this.$jsonp("https://restapi.amap.com/v3/assistant/coordinate/convert?key=44641f38739649861c9d7d31f69b4ac2&coordsys=".concat(this.coordsys, "&locations=").concat(point[0], ",").concat(point[1])).then(function (res) {
          if (res.info == 'ok') {
            _this3.mapCenter = res.locations.split(',');

            _this3.$refs.myMap.moveTo(res.locations.split(','));
          }
        });
      } else {
        this.$message_custom("请使用冒号（:）分隔经纬度", 'warn');
      }
    },
    show: function show(parmCenter, pointLists) {
      var _this4 = this;

      if (parmCenter && parmCenter[0] && parmCenter[1]) {
        this.mapCenter = parmCenter;
        this.coordinate = '';
      }

      if (this.coordinate && this.coordinate.indexOf(':') != -1) {
        this.mapCenter = this.coordinate.split(':');
        this.$nextTick(function () {
          _this4.$refs.myMap.moveTo(_this4.coordinate.split(':'));
        });
      }

      if (pointLists) {
        var pointList = pointLists.split(':');
        this.line = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
      }

      this.visible = true;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.mapReady();
    },
    handleOk: function handleOk() {
      if (this.isLocation) {
        this.$emit('mapChangeLocation', this.addr);
      }

      this.$emit('mapChange', this.mapCenter);
      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};